import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CustomerService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/Customers`);
    }

    public readCustomerUsers(customerRef: string, environment: string): Promise<IEntity[]> {
        return this.readAll(`GetCustomerUsers/${customerRef}/${environment}`);
    }

    public async resetCustomerTestData(customerRef: string): Promise<string> {
        const requestBody = { CustomerRef: customerRef };
        const result: string = await super.readAnyValueWithPost('ResetTestData', requestBody);
        return result;
    }

}